import type { BuyerPurchase } from './api';

/// What the buyer reads for each state of their online purchase (VEN-7).
export const buyerPurchaseStatusLabels: Record<BuyerPurchase['status'], string> = {
  CONFIRMED: 'Confirmada',
  PROCESSING: 'En proceso',
  REJECTED: 'Pago rechazado',
  REFUND_PENDING: 'Devolución en curso',
  REFUNDED: 'Devuelta',
  NOT_COMPLETED: 'No concretada',
};

/// The conditions a buyer accepts by paying online (P-D4, P-A3, P-A4, P-I5). PhoneTec validates
/// the words in X-2; until then, this is the team's draft.
export const purchaseConditions = [
  'Pagás el precio final, con IVA incluido, en Mercado Pago.',
  'El equipo se retira en el local: PhoneTec te contacta por WhatsApp para coordinar el retiro.',
  'Si la compra no se concreta, te devolvemos el pago.',
  'Te guardamos el equipo 30 minutos mientras pagás.',
];

/// Where a purchase is read: the return page from Mercado Pago, which asks the backend.
export const purchasePath = (purchaseId: string) =>
  `/checkout/return?purchase=${encodeURIComponent(purchaseId)}`;
